module.exports = __webpack_public_path__ + "static/img/b3.5eb1629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b3.png
// module id = +R5q
// module chunks = 1